/*
 * @Author: your name
 * @Date: 2021-04-14 14:47:17
 * @LastEditTime: 2022-04-29 13:51:58
 * @LastEditors: Teemo Ding
 * @Description: In User Settings Edit
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/tools.ts
 */

import { EnumLinkType } from '@/src/types/common/linkType';
import { EnumModuleType } from '@/src/types/common/module';
import { NULL } from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
// import {router } from 'react-router';
import {
  EnumCollapseId,
  generateDefaultCarousel,
  generateDefaultLongCanvas,
  generateDefaultSEOSetting,
  ProductType,
} from './common';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import {
  generateBody,
  initContentBody,
  initContentError,
} from 'src/constrains/DraggableModules/tools';
import { ChannelType } from 'src/types/common/SalesChannel';

const convertSpecificError = (specificErr) => {
  const _return = [];
  Object.values(specificErr || {}).forEach((err: string[]) => {
    _return.push(...(err || []));
  });
  return _return;
};

const convertDataFromServerToRedux = (response, isPrimary) => {
  const {
    productContent = {},
    product = {},
    salesChannel = {},
    reviewDisplayed = false,
  } = response;
  const isMini = get(salesChannel, 'channelType') === ChannelType.MiniProgram;
  const {
    uuid: productUuid = '',
    productType = '',
    products = [],
    product: productSingle,
    variants = [],
    averageRating = 0,
    reviewCount = 0,
  } = product;
  const {
    currency = '',
    uuid: salesChannelUuid = '',
    name: salesChannelName,
  } = salesChannel;
  const productName = productContent.productName || '';
  const subtitle = productContent.subtitle || '';
  const description = productContent.description || '';
  const remarks = productContent.remarks || '';
  const carousel = productContent.carousel || {};
  const longCanvas = productContent.longCanvas || {};
  const seo = productContent.seo || {};
  const contentUuid = productContent.uuid || '';
  const thumbnailImage = productContent.variantThumbnails;
  const optionsImage = productContent.optionsImage;
  const reviewKeywords = productContent.reviewKeywords || [];
  const contentModules = productContent.contentModules || [];
  const miniProgramShare = productContent.miniProgramShare || {};
  const miniProgramPageInfo = productContent.miniProgramPageInfo || {};

  const { carousel: carouselServerData } = carousel || {};

  const isNew = !contentUuid;

  const moduleContentOrder = [];
  const moduleContentStaticConfig = {};
  const moduleContentDynamicConfig = {};
  const collapseOpen = {
    [EnumCollapseId.seoSetting]: false,
    [EnumCollapseId.contentDetails]: false,
    [EnumCollapseId.carousel]: false,
    [EnumCollapseId.thumbnailImage]: false,
    [EnumCollapseId.optionsImage]: false,
    [EnumCollapseId.reviewKeywords]: false,
    [EnumCollapseId.miniProgramPageInfo]: false,
    [EnumCollapseId.miniProgramShare]: false,
  };
  const collapseErrorMsgDisplay = {
    [EnumCollapseId.seoSetting]: { hasError: false, display: !isNew },
    [EnumCollapseId.contentDetails]: { hasError: false, display: !isNew },
    [EnumCollapseId.carousel]: { hasError: false, display: !isNew },
    [EnumCollapseId.thumbnailImage]: { hasError: false, display: !isNew },
    [EnumCollapseId.optionsImage]: { hasError: false, display: !isNew },
    [EnumCollapseId.reviewKeywords]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramPageInfo]: { hasError: false, display: !isNew },
    [EnumCollapseId.miniProgramShare]: { hasError: false, display: !isNew },
  };

  initContentBody({
    contentBody: contentModules,
    moduleContentOrder,
    isNew,
    collapseOpen,
    collapseErrorMsgDisplay,
    moduleContentDynamicConfig,
    moduleContentStaticConfig,
  });

  const skuData = (productSingle ? [productSingle] : products).map(
    (item) => item.sku,
  );

  const codeData = (productSingle ? [productSingle] : products).map((item) =>
    [...[item.barcode], ...[...(item.codes || []).map((i) => i.title)]].join(
      ' ',
    ),
  );
  const contentPrice = [];
  products.forEach((item) => {
    contentPrice.push(item.defaultSalePrice || '');
  });
  const thumbnailImageData = {
    linkModules: calculateLinkModules(products, thumbnailImage, variants),
  };
  const carouselData = calculateCarousel(carouselServerData);
  //外层数据
  const data = {
    moduleContentOrder,
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    miniProgramShare: miniProgramShare || {},
    miniProgramPageInfo: miniProgramPageInfo || {},
    salesChannelProductUuid: productUuid,
    collapseErrorMsgDisplay,
    reviewDisplayed,
    collapseOpen,
    salesChannelName,
    salesChannelUuid,
    contentDetails: {
      sku: skuData.length ? skuData.join(' ') : '',
      productCode:
        codeData.length &&
        productType !== ProductType.MultiplePhysical &&
        productType !== ProductType.MultipleVirtual
          ? codeData.join(' ')
          : '',
      productName,
      productSubtitle: subtitle,
      productRemarks: remarks,
      productDescription: description,
      contentPrice,
      currency: currency,
    },
    hasModified: false,
    productType: productType,
    carousel: carouselData,
    longCanvas: (longCanvas || {}).linkModules || generateDefaultLongCanvas(),
    seoSetting: seo || generateDefaultSEOSetting(productName, description),
    thumbnailImage: thumbnailImageData,
    optionsImage: calculateOptionsImage(optionsImage),
    contentUuid,
    averageRating,
    reviewCount,
    loaded: true,
    // alias: aliasData || [],
    reviewKeywords: { tags: reviewKeywords },
  };
  if (!isNew) {
    let flag = false;
    const { hasError: seoContentDetails } = validateContentDetails(
      data.contentDetails,
    );
    if (seoContentDetails) {
      data.collapseOpen[EnumCollapseId.contentDetails] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.contentDetails].hasError =
        true;
      data.collapseErrorMsgDisplay[EnumCollapseId.contentDetails].display =
        true;
      flag = true;
      return data;
    }
    const { hasError: seoErr } = validateSeoSetting(data.seoSetting, isPrimary);

    if (seoErr && !isMini) {
      data.collapseOpen[EnumCollapseId.seoSetting] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].hasError = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.seoSetting].display = true;
      flag = true;
      return data;
    }
    const { hasError: carouselErr } = validateCarousel(data.carousel);
    if (carouselErr) {
      data.collapseOpen[EnumCollapseId.carousel] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.carousel].hasError = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.carousel].display = true;
      flag = true;
      return data;
    }
    const { hasError: thumbnailImageErr } = validateThumbnailImage(
      data.thumbnailImage,
    );
    if (
      thumbnailImageErr &&
      (productType == ProductType.MultiplePhysical ||
        productType == ProductType.MultipleVirtual)
    ) {
      data.collapseOpen[EnumCollapseId.thumbnailImage] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.thumbnailImage].hasError =
        true;
      data.collapseErrorMsgDisplay[EnumCollapseId.thumbnailImage].display =
        true;
      flag = true;
      return data;
    }

    const { hasError: optionsImageErr } = validateOptionsImage(
      data.optionsImage,
    );
    if (
      optionsImageErr &&
      (productType == ProductType.MultiplePhysical ||
        productType == ProductType.MultipleVirtual)
    ) {
      data.collapseOpen[EnumCollapseId.optionsImage] = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.optionsImage].hasError = true;
      data.collapseErrorMsgDisplay[EnumCollapseId.optionsImage].display = true;
      flag = true;
      return data;
    }

    initContentError({
      flag,
      moduleContentDynamicConfig,
      _a: data,
      moduleContentOrder,
      moduleContentStaticConfig,
      validationProps: {},
    });
  }
  return data;
};

const convertDataFromReduxToServer = (data) => {
  const {
    contentDetails = {},
    longCanvas = {},
    carousel = {},
    thumbnailImage = {},
    optionsImage = {},
    seoSetting = {},
    salesChannelProductUuid = '',
    contentUuid = '',
    duplicate,
    reviewKeywords,
    moduleContentOrder,
    salesChannelUuid = '',
    moduleContentStaticConfig,
    moduleContentDynamicConfig,
    miniProgramPageInfo,
    miniProgramShare,
  } = data;
  let { tags = [] } = reviewKeywords;
  const { text } = reviewKeywords;

  if (text) {
    tags = [text].concat(tags);
  }
  const _body = generateBody({
    moduleContentDynamicConfig,
    moduleContentOrder,
    moduleContentStaticConfig,
  });

  const { productName, productRemarks, productSubtitle, productDescription } =
    contentDetails;

  const seoSettingData = seoSetting.customized
    ? seoSetting
    : { ...seoSetting, title: productName, description: productDescription };

  const { staticData = {}, dynamicData = {} } = carousel;

  const {
    moduleName,
    moduleType,
    visible,
    posterType,
    autoPlay,
    intervalTime,
  } = staticData;

  const saveCarousel = {
    moduleName: '',
    moduleType: EnumModuleType.ProductContentCarousel,
    visible: true,
    sameAsOriginal: false,
    carousel: {
      moduleName,
      moduleType,
      visible,
      posterType,
      autoPlay,
      intervalTime,
      contentLinkModules: dynamicData,
    },
  };

  const saveLongCanvas = {
    moduleName: '',
    moduleType: EnumModuleType.LongCanvas,
    visible: true,
    linkModules: longCanvas,
  };

  let saveData = {};

  saveData = {
    salesChannelProductUuid:
      salesChannelProductUuid === NULL ? '' : salesChannelProductUuid,
    productName,
    remarks: productRemarks,
    subtitle: productSubtitle,
    description: productDescription,
    seo: seoSettingData,
    longCanvas: saveLongCanvas,
    contentModules: _body,
    carousel: saveCarousel,
    uuid: salesChannelProductUuid === NULL ? '' : contentUuid,
    variantThumbnails: thumbnailImage,
    optionsImage: optionsImage,
    duplicate,
    salesChannelUuid,
    reviewKeywords: tags,
    miniProgramPageInfo,
    miniProgramShare,
  };
  return saveData;
};

const validateContentDetails = (pageSetting) => {
  const specificErr = {};
  const { productName } = pageSetting || {};
  specificErr['nameError'] = [];
  if (!productName) {
    specificErr['nameError'].push(
      getI18nFromGeneral('general.error.productNamecannotbeempty'),
    );
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateCarousel = (pageSetting) => {
  const specificErr = {};
  const { dynamicData = [], sameAsOriginal } = pageSetting || {};

  dynamicData.forEach((item, index) => {
    const {
      draggableId,
      linkModule: { linkImage },
    } = item;
    if (!sameAsOriginal && !(linkImage || {}).uuid) {
      specificErr[`${draggableId}_imageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
  });

  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateThumbnailImage = (pageSetting) => {
  const specificErr = {};

  pageSetting.linkModules.forEach((item, index) => {
    const { linkImage = {}, draggableId } = item;
    if (!(linkImage || {}).url || '') {
      specificErr[`${draggableId}_imageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateOptionsImage = (optionsImage) => {
  const specificErr = {};

  if (optionsImage?.enableMultiOptionsImage) {
    optionsImage?.optionLabelModules.forEach((v) => {
      v?.optionLabelLinkModules.forEach((i) => {
        const { linkImage, draggableId } = i;

        if (!(linkImage || {}).url || '') {
          specificErr[`${draggableId}_imageError`] = [
            getI18nFromGeneral(
              'general.imageRequireError.theimagefieldcannotbeempty',
            ),
          ];
        }
      });
    });
  }

  return {
    hasError: Object.keys(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

const validateLongCanvas = (pageSetting) => {
  const specificErr = {};
  const generalError = [];
  if (!pageSetting || pageSetting.length == 0) {
    generalError.push(
      getI18nFromGeneral(
        'general.imageRequireError.theimagefieldcannotbeempty',
      ),
    );
  }
  pageSetting.forEach((item) => {
    const { draggableId, linkImage = {}, linkType } = item;
    if (!linkImage.url) {
      specificErr[`${draggableId}linkImageError`] = [
        getI18nFromGeneral(
          'general.imageRequireError.theimagefieldcannotbeempty',
        ),
      ];
    }
    if (!linkType) {
      specificErr[`${draggableId}linkTypeError`] = ['link cannot be empty'];
    }
  });
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: generalError,
  };
};

const validateSeoSetting = (seoSetting, isPrimary) => {
  const generalError = [];
  const specificErr = {};
  specificErr['slugError'] = [];
  const { slugValid } = seoSetting;
  if (slugValid === false && isPrimary) {
    specificErr['slugError'].push(
      'A page already exists with the same url slug.',
    );
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError,
  };
};

const calculateCarousel = (carouselServerData) => {
  //初始化draggableId
  const dynamicData = ((carouselServerData || {}).contentLinkModules || []).map(
    (item) => {
      if (!item.draggableId) {
        item.draggableId = randomNumber();
      }
      return item;
    },
  );

  const carouselData = carouselServerData
    ? {
        staticData: {
          posterType: carouselServerData.posterType,
          moduleType:
            carouselServerData.moduleType ||
            EnumModuleType.ProductContentCarousel,
          visible: carouselServerData.visible || false,
          autoPlay: carouselServerData.autoPlay || false,
          intervalTime: carouselServerData.intervalTime || 0,
        },
        dynamicData: dynamicData,
      }
    : generateDefaultCarousel();
  return carouselData;
};

const calculateOptionsImage = (optionsImage) => {
  return {
    ...optionsImage,
    optionLabelModules: optionsImage?.optionLabelModules.map((i) => ({
      ...i,
      optionLabelLinkModules: i?.optionLabelLinkModules.map((v) => ({
        ...v,
        draggableId: v.draggableId ? v.draggableId : randomNumber(),
      })),
    })),
  };
};

const calculateLinkModules = (products, thumbnailImage, variants) =>
  //交换thumbnailImage和products里的数据
  ((thumbnailImage || {}).linkModules || []).map((item, index) => {
    const productIndex = products.filter(
      (product) => product.uuid == item.uuid,
    );
    const variantsIndex = variants.filter(
      (variant) => variant.productUuid == item.uuid,
    );

    const title = ((productIndex || [])[0] || {}).name;
    const thumbnailUrl = ((productIndex || [])[0] || {}).thumbnailUrl;
    const draggableId = (item || {}).draggableId;
    const linkImage = (item || {}).linkImage;
    return {
      draggableId: draggableId ? draggableId : randomNumber(),
      title: title,
      subtitle: (variantsIndex || [])[0]
        ? ((variantsIndex || [])[0].values || [])
            .map((value) => value.value)
            .join('/')
        : '',
      linkImage: linkImage
        ? linkImage
        : {
            uuid: '',
            url: thumbnailUrl,
          },
      linkType: EnumLinkType.None,
      uuid: item.uuid,
    };
  });

export {
  convertDataFromReduxToServer,
  convertDataFromServerToRedux,
  validateCarousel,
  validateContentDetails,
  validateLongCanvas,
  validateSeoSetting,
  validateThumbnailImage,
  validateOptionsImage,
};
